/* eslint-disable @typescript-eslint/no-unsafe-member-access -- TODO: remove this */
/* eslint-disable @typescript-eslint/no-unsafe-assignment  -- TODO: remove this */

export interface Translations {
  [locale: string]: Record<string, string> | undefined;
}

export const extractTranslations = (jsonAttributes?: string) => {
  const attributes = jsonAttributes ? JSON.parse(jsonAttributes || '{}') : {};

  const locale =
    document.documentElement.lang ||
    (attributes.DefaultLanguage ? (attributes.DefaultLanguage as string) : 'en');

  const translations: Translations = attributes.Translations ?? {};

  const messages: Record<string, string> = translations[locale] ?? {};

  return {
    locale,
    messages,
    translations,
  };
};
